var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfflineBusinessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8664",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8664",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAD0ElEQVR4nO2cz4oUVxTGz1U3KjqiuEqIBIJR3yBZJoqZzBhIIiRP4BsE8gQRBcnah3CZP65ERHArCdGFCTg9EyFkQiYhM6CBXxZVDu3p7qpb1VXm2PX9oBe3+7unDufre6uq6942E0IIIYQQQoiXS8oVAitmdt3MXusvnYVk3cwupZS+yxE3MWRkZq+3zWrgjFJKb+QImxhC+3xESimr1nv6TkQ0Y1/bjrmOD5W2M4pGSDBkSDBkSDBan0N01dUPWSME2Nt3IotObg1zp6x358hFFLyTI8o1ZGWORERBdzUEfuRFPuss+IICfO5q9kNXgU+4wM+AI50EX2CAJeCpq92bdf1ypqyPXPtOSunPdmkOh5TSlpnddW/XTls5hvgg3+QmJSZqNd95BDgI7Lhhd2quoAMCOOVqtwMcnCfgqgv4qMN8BwHwyNVwtUpfN2V96NrfzpfeIPE1W24dCfjZuds+2EABll0Nf2kb6IwLtA0c6DjfhQfYD/zjanl6lr5qyjrv2rdSStvdpDkcUko7Znbbve1ru0uVIWdd+2bVgYELwB/AE8Dfu/wf+k9L/e+Z+otj+k8y9KvABvArxYqcKr537XN18acdcDN3mJX638a0TzLiR9ZvZOg3xvSjGu1pV8vNuvjTgvztghyr0B5mkkPS7+qPO+1fs7RVU9aaa/spbJz3p7z3nvS7+CnqcYV2OsDXztURcHSKbgl4OOUb8xOwJD3HeHF6A7hWV/8JgJMUv+yOs0Zx8jtcvj6ekdxzHpSaoeovUtRsnGfAW7PqXrm2CrhqZl80dlNUcSWl9OWsD+sM2WdmW2aWe0N4o4xZe9k4UP22mS2llP7N1E9SMTzHeQp8BewtX5eZfDgzZP0urY2oMOQexT3KFnAfuAKcnNLv7fKz+6V2aPrNslaNDKldn+uDaE1vM5rWTysXgyFDgiFDgiFDgiFDgtF69fssGM5u3Ua7a3Pp/LKXYe3Wrd1d27R+fRgyqH0jTeuh+5BXjM7PIZ6+7+xf9i8Jfc8AGiHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBkCHBCG8IsAKsU+xPabwte97+4Wi6NrWpPiPeaCyc39VVe7y6/i3y6bUe4UeIcAQYIcvlt3wN+KDp8er6t8in13r0vupk0Z+pa9XJgiNDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgiFDgtH4iaGYDz0xfMXIMWS99yyGQ+VfkpvlGXLJZEoXjKyopRBCCCGEEEKE4j/wEj7s3qbhFAAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineBusinessIcon);
export default __webpack_public_path__ + "static/media/OfflineBusinessIcon.094e935440d706641bfa86a65b17a4f7.svg";
export { ForwardRef as ReactComponent };